// Copyright ©️ 2026 eVolve MEP, LLC

export const QUESTION_MARK_PATH_TOKENS: (string | number)[] = [
  'M',
  10.9014,
  15.3178,
  'C',
  10.9014,
  14.1954,
  11.0307,
  13.336,
  11.2894,
  12.7398,
  'C',
  11.548,
  12.1436,
  12.088,
  11.4825,
  12.9093,
  10.7567,
  'C',
  13.5486,
  10.1873,
  14.0333,
  9.67085,
  14.3631,
  9.20748,
  'C',
  14.693,
  8.7441,
  14.8579,
  8.21876,
  14.8579,
  7.63144,
  'C',
  14.8579,
  6.85226,
  14.5926,
  6.20463,
  14.0619,
  5.68854,
  'C',
  13.5311,
  5.17244,
  12.8005,
  4.9144,
  11.8699,
  4.9144,
  'C',
  11.0208,
  4.9144,
  10.3598,
  5.14187,
  9.88684,
  5.59682,
  'C',
  9.41405,
  6.05193,
  9.05495,
  6.55984,
  8.80954,
  7.12055,
  'L',
  7,
  6.32535,
  'C',
  7.38521,
  5.37579,
  7.98649,
  4.58414,
  8.80384,
  3.95038,
  'C',
  9.62119,
  3.31679,
  10.6432,
  3,
  11.8699,
  3,
  'C',
  13.4716,
  3,
  14.7043,
  3.45156,
  15.5681,
  4.35468,
  'C',
  16.4319,
  5.2578,
  16.8637,
  6.32973,
  16.8637,
  7.57046,
  'C',
  16.8637,
  8.34584,
  16.6957,
  9.03008,
  16.3596,
  9.62318,
  'C',
  16.0233,
  10.2161,
  15.5132,
  10.8336,
  14.8294,
  11.4756,
  'C',
  13.9687,
  12.265,
  13.4358,
  12.8875,
  13.2305,
  13.3432,
  'C',
  13.0251,
  13.7989,
  12.9224,
  14.4571,
  12.9224,
  15.3178,
  'Z',
  'M',
  11.8699,
  21,
  'C',
  11.4644,
  21,
  11.1151,
  20.8535,
  10.8221,
  20.5605,
  'C',
  10.5291,
  20.2675,
  10.3826,
  19.9182,
  10.3826,
  19.5127,
  'C',
  10.3826,
  19.1072,
  10.5291,
  18.7579,
  10.8221,
  18.4649,
  'C',
  11.1151,
  18.1719,
  11.4644,
  18.0254,
  11.8699,
  18.0254,
  'C',
  12.2754,
  18.0254,
  12.6247,
  18.1719,
  12.9177,
  18.4649,
  'C',
  13.2107,
  18.7579,
  13.3572,
  19.1072,
  13.3572,
  19.5127,
  'C',
  13.3572,
  19.9182,
  13.2107,
  20.2675,
  12.9177,
  20.5605,
  'C',
  12.6247,
  20.8535,
  12.2754,
  21,
  11.8699,
  21,
  'Z',
];
